"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const AuthException_1 = __importDefault(require("../Exception/AuthException"));
const exception_1 = require("@almservices-cl/exception");
const exception_2 = require("@almservices-cl/exception");
const sleep_1 = require("../Util/sleep");
class ClientMock {
    constructor(responseMap, responseDelay = 0) {
        this.interceptors = [];
        // eslint-disable-next-line @typescript-eslint/no-explicit-any,@typescript-eslint/explicit-module-boundary-types
        this.get = async (url, body, options) => {
            var _a;
            await (0, sleep_1.sleep)(this.responseDelay);
            for (const interceptor of this.interceptors) {
                await interceptor.intercept({
                    url,
                    data: body,
                    headers: {},
                    options,
                    method: "get",
                    id: "4",
                });
            }
            const responseItem = this.responseMap.get(url);
            let data = responseItem === null || responseItem === void 0 ? void 0 : responseItem.data;
            if (responseItem !== undefined && data === null) {
                responseItem.dataIterationCursor = responseItem.dataIterationCursor || 0;
                data = (_a = responseItem.dataIteration) === null || _a === void 0 ? void 0 : _a[responseItem.dataIterationCursor++];
            }
            if ((responseItem === null || responseItem === void 0 ? void 0 : responseItem.status) === 200) {
                this.assertBody(responseItem, body);
                return data;
            }
            // TODO: Defaulted to {}, but Runtime error message is not adequate
            throw this.fail(responseItem || {});
        };
        this.logIn = async (_credentials) => {
            await (0, sleep_1.sleep)(this.responseDelay);
            return {
                token: "foo",
                refreshToken: "bar",
                expiresIn: 2000,
            };
        };
        // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
        this.post = async (url, body) => {
            await (0, sleep_1.sleep)(this.responseDelay);
            const responseItem = this.responseMap.get(url);
            const data = responseItem === null || responseItem === void 0 ? void 0 : responseItem.data;
            if ((responseItem === null || responseItem === void 0 ? void 0 : responseItem.status) === 200) {
                this.assertBody(responseItem, body);
                return data;
            }
            // TODO: Defaulted to {}, but Runtime error message is not adequate
            this.fail(responseItem || {});
        };
        this.refreshToken = async () => {
            await (0, sleep_1.sleep)(this.responseDelay);
            return {
                token: "baz",
                refreshToken: "quux",
                expiresIn: 2000,
            };
        };
        this.assertBody = (response, body) => {
            if (response.body !== undefined) {
                expect(body).toMatchObject(response.body);
            }
        };
        this.execute = async (_request) => {
            throw new exception_2.RuntimeException("Not Implemented");
        };
        this.delete = (_url, _body, _options, _headers, _intercept) => {
            throw new exception_2.RuntimeException("Not Implemented");
        };
        this.responseDelay = responseDelay;
        this.responseMap = responseMap;
    }
    fail(responseItem) {
        switch (responseItem.status) {
            case undefined:
                throw new exception_2.RuntimeException("No Status code defined");
            case 401:
                throw new AuthException_1.default();
            default:
                throw new exception_1.NetworkException(`Request failed with status code ${responseItem.status}`);
        }
    }
    registerInterceptor(interceptor) {
        this.interceptors.push(interceptor);
    }
}
exports.default = ClientMock;
//# sourceMappingURL=ClientMock.js.map